"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authPromoContract = void 0;
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const prize_1 = require("../prize");
const models_1 = require("../winner/models");
const models_2 = require("./models");
const ZUnclaimedPromoPrizeReward = models_2.ZPromoPrizeRewardSelect.pick({
    id: true,
    code: true,
    createdAt: true,
    expiresAt: true,
    status: true,
}).extend({
    prizeSlug: zod_1.z.string(),
    prizeTitle: zod_1.z.string(),
    prizeSubheading: zod_1.z.string(),
    prizeImageLocation: zod_1.z.string(),
});
const ZClaimedPromoPrizeReward = ZUnclaimedPromoPrizeReward.extend({
    chosenPrizeProducts: prize_1.ZProductSelect.pick({
        id: true,
        name: true,
        autoFulfilmentCode: true,
    })
        .extend({ prizeOrderProductId: zod_1.z.string() })
        .array(),
});
const c = (0, core_1.initContract)();
exports.authPromoContract = c.router({
    getUpgradeOffer: {
        method: 'GET',
        path: '/upgrade-offer',
        query: zod_1.z.object({
            planCode: zod_1.z.optional(zod_1.z.string()).nullable(),
        }),
        responses: {
            200: zod_1.z.object({
                promoCode: zod_1.z.optional(models_2.ZPromoCodeSelect),
            }),
            400: c.type(),
            404: c.type(),
        },
        summary: 'Get prize wins of a draw',
    },
    getCancellationOffer: {
        method: 'GET',
        path: '/cancellation-offer',
        query: zod_1.z.object({
            planCode: zod_1.z.optional(zod_1.z.string()).nullable(),
        }),
        responses: {
            200: zod_1.z.object({
                promoCode: zod_1.z.optional(models_2.ZPromoCodeSelect),
            }),
            400: c.type(),
            404: c.type(),
        },
        summary: 'Get cancellation offer promo code',
    },
    activatePromoCodeForSubscription: {
        method: 'POST',
        path: '/activate-promo-code',
        body: zod_1.z.object({
            subscriptionId: zod_1.z.string(),
            code: zod_1.z.string(),
            evalData: zod_1.z.optional(dbJsonModels_1.ZPromoConditions.partial()),
        }),
        responses: {
            200: zod_1.z.object({
                promoCodeRecurring: models_2.ZPromoCodeRecurringSelect,
            }),
            400: c.type(),
        },
        summary: 'Activate a promo code for a subscription',
    },
    getPromoPrizeRewardsOfPlayer: {
        method: 'GET',
        path: '/promo-prize-rewards',
        responses: {
            200: zod_1.z.object({
                unclaimed: ZUnclaimedPromoPrizeReward.array(),
                claimed: ZClaimedPromoPrizeReward.array(),
            }),
        },
        summary: 'Get promo prize rewards of a player',
    },
    claimPromoPrizeReward: {
        method: 'POST',
        path: '/promo-prize-reward/:id/claim',
        pathParams: zod_1.z.object({
            id: zod_1.z.string(),
        }),
        body: zod_1.z
            .object({
            prizeId: zod_1.z.coerce.number(),
            productId: zod_1.z.coerce.number().optional(),
        })
            .merge(models_1.ZPrizeOrderInsert.pick({
            deliveryStreet: true,
            deliveryCity: true,
            deliveryPostcode: true,
            emailAddress: true,
            phoneNumber: true,
            additionalInfoFromPlayer: true,
        })),
        responses: {
            200: zod_1.z.object({
                prizeOrderId: zod_1.z.string(),
                prizeOrderProductIds: zod_1.z.string().array(),
            }),
            400: c.type(),
        },
        summary: 'Claim a promo prize reward',
    },
}, {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=promo.auth.contract.js.map